import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { useAuthStore } from './authStore'

interface ImportData {
  [key: string]: any
}

interface ImportError {
  index: number
  error: string
  student: any
  rawRow?: any
}

interface ImportState {
  // State
  importedData: ImportData[]
  errors: ImportError[]
  activeTab: string

  // Actions
  setImportedData: (data: ImportData[]) => void
  setErrors: (errors: ImportError[]) => void
  setActiveTab: (tab: string) => void
  clearImportData: () => void
  addImportedData: (data: ImportData[]) => void
  clearAllStudents: () => void
}

export const useImportStore = create<ImportState>()(
  devtools(
    persist(
      (set, get) => ({
        // Initial state
        importedData: [],
        errors: [],
        activeTab: 'import',

        setImportedData: (data: ImportData[]) => {
          set({ importedData: data })
        },

        setErrors: (errors: ImportError[]) => {
          set({ errors })
        },

        setActiveTab: (tab: string) => {
          set({ activeTab: tab })
        },

        clearImportData: () => {
          set({
            importedData: [],
            errors: [],
            activeTab: 'import',
          })
        },

        addImportedData: (data: ImportData[]) => {
          const currentData = get().importedData
          set({ importedData: [...currentData, ...data] })
        },

        clearAllStudents: () => {
          set({
            importedData: [],
            errors: [],
            activeTab: 'import',
          })
        },
      }),
      {
        name: 'import-store',
        // Persist all data
        partialize: (state) => ({
          importedData: state.importedData,
          errors: state.errors,
          activeTab: state.activeTab,
        }),
      },
    ),
    {
      name: 'import-store',
    },
  ),
)

// Export the ImportError interface so other components can use it
export type { ImportError }

// Subscribe to auth store logout to clear import data
useAuthStore.subscribe((state, prevState) => {
  // Clear import data when user logs out
  if (prevState.isAuthenticated && !state.isAuthenticated) {
    useImportStore.getState().clearAllStudents()
  }
})
